export default __webpack_public_path__ + "static/media/honduras.4554d6cd.png";